
import { IDataAccessor, AbstractAccessorService } from "@core/data-access";
import { IResponse } from "@core/data-access/model";
import { IWoocCurrencyRestService } from "./wooc-currency-rest";
import { IWoocCurrency } from "../../../model/domain/wooc-currency";

export class WoocCurrencyRestService extends AbstractAccessorService<IWoocCurrency> implements IWoocCurrencyRestService {
    public readonly $name: string = "woocCurrencyRestService";

    public static readonly $inject: string[] = ["$accessor"];

    constructor(public $accessor: IDataAccessor<IWoocCurrency>) {
        super();
    }

    /**
     * @description 获取WooCommerece默认货币
     * @returns 
     */
    public default(storeId: string): angular.IPromise<IResponse<IWoocCurrency>> {
        return this.$accessor<IWoocCurrency, { storeId: string }, string>(this.$name, "default", {
            parameter: {
                storeId: storeId
            }
        })
    }
}